import Box from "@mui/material/Box";
import { Button } from "react-admin";
import { DateTime } from "luxon";
import { type EditCalendarEventDto, serverAPI } from "../../api/server.api";
import { ASFCourseSession } from "../../model/autovioCalendarEvents";
import { Row } from "../../misc/Row";
import { InstructorInput } from "../../inputs/InstructorInput";
import { DateTimeInput } from "../../inputs/DateTimeInput";
import { Column } from "../../misc/Column";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import { SaveButton2 } from "../../buttons/SaveButton2";
import { Form2 } from "../../misc/Form2";
import { assertValid } from "../../backoffice.utils";

interface EditASFCourseSessionFormProps {
  event: ASFCourseSession;
  closeEditMode: () => void;
}

interface EditASFCourseSessionFormValues {
  start: DateTime;
  instructorId: string;
}

export const EditASFCourseSessionForm = ({ event, closeEditMode }: EditASFCourseSessionFormProps) => {
  const onSubmit = async (formValues: EditASFCourseSessionFormValues) =>
    runSafely(
      async () => {
        const start = assertValid(formValues.start, "start");
        const end = start.plus(event.end.diff(event.start));
        const dto: EditCalendarEventDto = {
          type: "ASFCourseSession",
          start: start.toISO(),
          end: end.toISO(),
          instructorId: formValues.instructorId,
        };
        await serverAPI.editCalendarEvent({ eventId: event.id, dto });
      },
      { onSuccess: closeEditMode },
    );

  return (
    <Form2 defaultValues={{ start: event.start, instructorId: event.instructorId }} onSubmit={onSubmit}>
      <Box sx={{ minWidth: "450px" }}>
        <Column sx={{ gap: "20px" }}>
          <DateTimeInput allowPastDates source="start" sx={{ mt: "5px" }} size="small" />
          <InstructorInput source="instructorId" size="small" />
        </Column>
        <Row sx={{ pt: 1, justifyContent: "space-between", mt: "20px" }}>
          <Button
            startIcon={<NavigateBeforeIcon />}
            label="Zurück"
            variant="outlined"
            size="medium"
            onClick={closeEditMode}
          />
          <SaveButton2 />
        </Row>
      </Box>
    </Form2>
  );
};
